import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-612e4efc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-eer-investment-money" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-3 mb-3" }, "D. Investment Money", -1))
const _hoisted_3 = {
  key: 0,
  class: "questions-main"
}
const _hoisted_4 = {
  key: 0,
  class: "sub-heading"
}

export function render(_ctx, _cache) {
  const _component_RadioButtonHorizontal = _resolveComponent("RadioButtonHorizontal")
  const _component_RadioButtonVertical = _resolveComponent("RadioButtonVertical")
  const _component_RadioButtonSubQuestions = _resolveComponent("RadioButtonSubQuestions")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.loadingContent)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          (_ctx.formEERData?.investmentMoney?.atcsMainQuestions?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formEERData.investmentMoney.atcsMainQuestions, (q, i) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (q.atcsQuestionTypeId==1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(q.wording), 1))
                      : _createCommentVNode("", true),
                    (q.atcsQuestionTypeId==10)
                      ? (_openBlock(), _createBlock(_component_RadioButtonHorizontal, {
                          key: 1,
                          class: "mt-3 mb-3",
                          question: _ctx.formEERData.investmentMoney.atcsMainQuestions[i],
                          "onUpdate:question": $event => ((_ctx.formEERData.investmentMoney.atcsMainQuestions[i]) = $event),
                          onValidForm: $event => (_ctx.validationForm(i, $event))
                        }, null, 8, ["question", "onUpdate:question", "onValidForm"]))
                      : _createCommentVNode("", true),
                    (q.atcsQuestionTypeId==11)
                      ? (_openBlock(), _createBlock(_component_RadioButtonVertical, {
                          key: 2,
                          class: "mt-3 mb-3",
                          question: _ctx.formEERData.investmentMoney.atcsMainQuestions[i],
                          "onUpdate:question": $event => ((_ctx.formEERData.investmentMoney.atcsMainQuestions[i]) = $event),
                          onValidForm: $event => (_ctx.validationForm(i, $event))
                        }, null, 8, ["question", "onUpdate:question", "onValidForm"]))
                      : _createCommentVNode("", true),
                    (q.atcsQuestionTypeId==16)
                      ? (_openBlock(), _createBlock(_component_RadioButtonSubQuestions, {
                          key: 3,
                          class: "mt-3 mb-3",
                          question: _ctx.formEERData.investmentMoney.atcsMainQuestions[i],
                          "onUpdate:question": $event => ((_ctx.formEERData.investmentMoney.atcsMainQuestions[i]) = $event),
                          onValidForm: $event => (_ctx.validationForm(i, $event))
                        }, null, 8, ["question", "onUpdate:question", "onValidForm"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}